/**
 * 教师端设置相关API
 * Teacher Settings API
 * 包含：学科分类管理、首页banner管理、禁言管理
 */
import request from '@/utils/request'

// 获取学科分类列表
export function getTeacherSubjectCategories(params) {
  return request({
    url: '/school/yee_category_list',
    method: 'get',
    params
  })
}

// 添加学科分类
// 传入参数为form-data
export function addTeacherSubjectCategory(data) {
  return request({
    url: '/school/yee_category_add',
    method: 'post',
    data
  })
}

// 更新修改学科分类
// 也可实现启用禁用
// 传入参数为form-data
export function updateTeacherSubjectCategory(data) {
  return request({
    url: '/school/yee_category_update',
    method: 'post',
    data
  })
}

// 删除学科分类
export function deleteTeacherSubjectCategory(params) {
  return request({
    url: '/school/yee_category_delete',
    method: 'get',
    params
  })
}

// ==================== 首页banner管理相关API ====================

/**
 * 查询轮播图列表（首页使用，无需登录）
 * @param {Object} params
 * @param {String} params.pageNum 页码
 * @param {String} params.pageSize 每页数量
 * @returns {Promise}
 */
export function getBannerList(params) {
  return request({
    url: '/course/sl_sch_banner_list',
    method: 'get',
    params
  })
}

/**
 * 查询轮播图列表(需登录)
 * @param {Object} params
 * @param {String} params.pageNum 页码
 * @param {String} params.pageSize 每页数量
 * @returns {Promise}
 */
export function getBannerListAdmin(params) {
  return request({
    url: '/manage/sl_sch_banner_list',
    method: 'get',
    params
  })
}

/**
 * 获取轮播图详情
 * @param {Object} params
 * @param {String} params.id ID编号
 * @param {String} params.schoolId 学校ID
 * @returns {Promise}
 */
export function getBannerInfo(params) {
  return request({
    url: '/manage/sl_sch_banner_info',
    method: 'get',
    params
  })
}

/**
 * 添加轮播图
 * @param {Object} data
 * @param {Number} data.schoolId 学校ID
 * @param {String} data.name 轮播图名称
 * @param {String|null} data.image 轮播图图片链接
 * @param {Number} data.allow 是否启用（1启用，0禁用）
 * @param {Number} data.link 链接类型（默认为 0）
 * @param {Number} data.sort 排序权重
 * @returns {Promise}
 */
export function addBanner(data) {
  return request({
    url: '/manage/sl_sch_banner_add',
    method: 'post',
    data
  })
}

/**
 * 修改轮播图
 * @param {Object} data
 * @param {Number} data.id 轮播图ID
 * @param {Number} data.schoolId 学校ID
 * @param {String} data.name 轮播图名称
 * @param {String|null} data.image 轮播图图片链接
 * @param {Number} data.allow 是否启用（1启用，0禁用）
 * @param {Number} data.link 链接类型（默认为 0）
 * @param {Number} data.sort 排序权重
 * @returns {Promise}
 */
export function updateBanner(data) {
  return request({
    url: '/manage/sl_sch_banner_update',
    method: 'post',
    data
  })
}

/**
 * 删除轮播图
 * @param {Object} params
 * @param {String} params.id ID编号
 * @param {String} params.schoolId 学校ID
 * @returns {Promise}
 */
export function deleteBanner(params) {
  return request({
    url: '/manage/sl_sch_banner_delete',
    method: 'get',
    params
  })
}

/**
 * 条件查询轮播图
 * @param {Object} data
 * @param {Number} data.pageNum 页码（必传）
 * @param {Number} data.pageSize 每页数量（必传）
 * @param {Number} data.schoolId 学校ID （必传）
 * @param {String} data.name 轮播图名称（可选）
 * @param {Number} data.allow 是否启用（1启用，0禁用）（可选）
 * @returns {Promise}
 */
export function searchBanner(data) {
  return request({
    url: '/manage/sl_sch_banner_search',
    method: 'post',
    data
  })
}

// ==================== 禁言管理相关API ====================

/**
 * 查询禁言列表
 * @param {Object} params
 * @param {String} params.pageNum 页码
 * @param {String} params.pageSize 每页数量
 * @param {String} params.schoolId 学校ID
 * @returns {Promise}
 */
export function getMutedList(params) {
  return request({
    url: '/school/yee_muted_list',
    method: 'get',
    params
  })
}

/**
 * 删除禁言信息
 * @param {Object} params
 * @param {String} params.schoolId 学校ID
 * @param {String} params.id ID编号
 * @returns {Promise}
 */
export function deleteMuted(params) {
  return request({
    url: '/school/yee_muted_delete',
    method: 'get',
    params
  })
}

/**
 * 条件查询禁言列表
 * @param {Object} data
 * @param {Number} data.pageNum 页码
 * @param {Number} data.pageSize 每页数量
 * @param {Number} data.schoolId 学校ID
 * @param {Number} data.userId 用户ID（可选）
 * @returns {Promise}
 */
export function searchMuted(data) {
  return request({
    url: '/school/yee_muted_search',
    method: 'post',
    data
  })
}

/**
 * 添加禁言账户
 * @param {Object} data
 * @param {Number} data.schoolId 学校ID
 * @param {Number} data.userId 用户ID
 * @param {Number} data.unlockTime 解禁时间戳
 * @param {String} data.forum 论坛名称
 * @param {Number} data.teacherId 教师ID
 * @param {String} data.content 评论内容
 * @param {Number} data.replyId 回复ID
 * @returns {Promise}
 */
export function addMuted(data) {
  return request({
    url: '/school/yee_muted_add',
    method: 'post',
    data
  })
}